import React from 'react';
import styles from './element-parallax.module.css';

class ElementParallax extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.refs['img'].complete) {
            this.childrenLoaded(this.childElem);
        }

        window.addEventListener('resize', () => this.childrenLoaded(this.childElem), false);
    }

    childrenLoaded (elem) {
        const childrenHeight = elem.clientHeight;
        this.elementHeight = childrenHeight * .8;
        this.elem.style.height = `${this.elementHeight}px`;

        this.totalScrollDistance = this.elementHeight + window.innerHeight;
        this.translateDistance = childrenHeight * .2;

        this.scrollHandler();
    }

    setTranslate () {
        const elemTop = this.elem.getBoundingClientRect().top;
        const windowScrollDistance = window.innerHeight - elemTop;

        if (windowScrollDistance < 0 || windowScrollDistance > this.totalScrollDistance) {
            return;
        } else {
            const translatePercentage = (windowScrollDistance / this.totalScrollDistance) * 100;
            this.childElem.style.transform = `translateY(-${((this.translateDistance / 100) * translatePercentage).toFixed(3)}px)`;
        }
    }

    scrollHandler () {
        this.setTranslate();
        window.requestAnimationFrame(this.scrollHandler.bind(this));
    }

    render() {
        return (
            <div ref={(e) => this.elem = e} className={styles.container}>
                <div ref={(e) => this.childElem = e} onLoad={(event) => this.childrenLoaded(event.target)}>
                    {React.cloneElement(this.props.children, { ref: 'img' })}
                </div>
            </div>
        );
    }

}

export default ElementParallax;


// WEBPACK FOOTER //
// ./src/components/ElementParallax/index.js